import { gql } from "graphql-tag";
import React from "react";
import { useQuery } from "@apollo/client";
import { Link, useNavigate } from "react-router-dom";
import MaterialTable from "@material-table/core";
import { ServerError } from "components/graphql-views";

const GET_ORGS = gql`
  query orgsList {
    organizations {
      id
      name
    }
  }
`;

type ResData = {
  organizations: [{ id: string; name: string }];
}

const Organizations: React.FC = () => {
  const navigate = useNavigate();
  const { loading, error, data } =
    useQuery<ResData>(GET_ORGS, { fetchPolicy: "cache-and-network" });
  if (error) return <ServerError desc={error.message} />;
  if (!data) return null;
  return (
    <MaterialTable
      actions={[
        {
          icon: "add",
          tooltip: "Create Organization",
          isFreeAction: true,
          onClick: () => navigate("/dash/admin/organizations/new"),
        },
      ]}
      title="Organizations"
      isLoading={loading}
      data={data && data.organizations}
      options={{
        pageSize: 30,
        pageSizeOptions: [10, 20, 30, 50],
      }}
      columns={[
        {
          field: "name",
          title: "Organization Name",
          defaultSort: "asc",
          render: ({ id, name }) => <Link to={`/dash/admin/organizations/${id}`}>{name}</Link>,
        },
      ]} />
  );
};


export default Organizations;
